<template>
  <div style="height:100%;">
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header style="padding:0.8rem 0.8rem 0rem 0.8rem;">
        <div class="zj-button-bar" v-if="IsEdit">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
      </zj-layout-header>
      <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
        <el-table :data="tableData" border style="width: 100%" height="100%">
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center">
              <template #default="{ row }">
                  <span>{{ row.person.name || ''}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="genderTranslated" label="性别" align="center">
              <template #default="{ row }">
                  <span>{{ row.person.genderTranslated || ''}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="title" label="职级" align="center">
              <template #default="{ row }">
                  <span>{{ row.person.title || ''}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" align="center">
              <template #default="{ row }">
                  <span>{{ row.person.age || ''}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="birthday" label="出生日期" width="180" align="center">
              <template #default="{ row }">
                  <span>{{ row.person && row.person.birthday ?  row.person.birthday.split(' ')[0] : ''}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="PhoneNum" label="联系电话" align="center">
              <template #default="{ row }">
                  <span>{{ row.person.contactNo || ''}}</span>
              </template>
          </el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.$index,scope.row)"
                type="text"
                size="small"
              >查看</el-button>
              <el-button v-if="IsEdit"
                @click="deleteClick(scope.$index,scope.row)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </zj-layout-main>
    </zj-layout-container>
    <el-dialog v-dialogDrag :visible.sync="dialogInfoVisible" title="通讯录详情">
      <Addressbookinfo @onClose="onClose" opentype="true" :isHeadVisiable="false" :query="queryData" style="height:64rem;"></Addressbookinfo>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="dialogTableVisible" title="选择队员" width="100rem" @opened="onopened">
      <zj-layout-container style="height: 60rem;">
        <zj-layout-main style="padding:0;">
          <el-table
            ref="multipleTable"
            :data="DialogtableData"
            :append-to-body="true"
            @selection-change="handleSelectionChange"
            border
            style="width:100%"
            height="100%"
          >
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="genderTranslated" label="性别" align="center"></el-table-column>
            <el-table-column prop="title" label="职级" align="center"></el-table-column>
            <el-table-column prop="age" label="年龄" align="center"></el-table-column>
            <el-table-column prop="birthday" label="出生日期" width="180" align="center">
                <template #default="{ row }">
                  <span>{{ row.birthday ? row.birthday.split(' ')[0] : ''}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="contactNo" label="联系电话" align="center"></el-table-column>
            <el-table-column type="selection" width="55" align="center"></el-table-column>
          </el-table>
        </zj-layout-main>
        <zj-layout-footer style="text-align: center;margin-bottom:-1rem;padding-top:2rem;">
          <el-button @click="onBack()">取消</el-button>
          <el-button @click="onOk()">确定</el-button>
        </zj-layout-footer>
      </zj-layout-container>
    </el-dialog>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import Addressbookinfo from "./Addressbookinfo";
import { listNoUsed } from "@/api/src/emergency_person";
import { batchSumbit, list, remove, detail } from "@/api/src/emergency_person_team";

export default {
  name: "ZjResourcesTeamPlayerlist",
  controller: "EmergencyResource",
  action: "ResourcesTeamPlayerlist",
  props: {
    query: {
      type: String,
      id: String,
      teamBelong:String,
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      tableData: [],
      selectData: null,
      dialogInfoVisible: false,
      queryData: {},
      dialogTableVisible: false,
      DialogtableData: [],
      multipleSelection: [],
      IsEdit: false
    };
  },
  components: {
    Addressbookinfo
  },
  mounted: function() {
    this.search();
    this.IsEdit = this.query.type == "edit" ? true : false;
  },
  methods: {
    search(){
      this.tableData = []
      let { id } = this.query;
      let searchInfo = {
        teamId: id,
        size: 2000,
        current: 1,
      };
      this.loading = true;
      this.loadingText = '加载中...';
      list(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    searchDiaTabData() {
      this.multipleSelection = []
      this.DialogtableData = []
      let { id, teamBelong } = this.query;
      let searchInfo = {
        size: 2000,
        current: 1,
        organizationNature: teamBelong,
        // teamId:id
      };
      this.loading = true;
      this.loadingText = '加载中...';
      listNoUsed(searchInfo)
        .then(r => {
          r = r.data;
          this.DialogtableData = r
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    //查看详细
    handleClick(index, row) {
      this.queryData = {
        type: 'search',
        id: row.personId,
        belongDeptType: row.belongDeptType
      };
      this.dialogInfoVisible = true;
    },
    //添加
    onAdd() {
      this.dialogTableVisible = true;
      this.searchDiaTabData()
    },
    onopened() {
      // this.toggleSelection(this.multipleSelection);
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      // if (rows) {
      //   rows.forEach(row => {
      //     this.$refs.multipleTable.toggleRowSelection(row);
      //   });
      // }
    },
    onOk() {
      if(!this.multipleSelection.length){
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
        return
      }
      let { id } = this.query,personIdList = this.multipleSelection.map(item=>item.id).concat(this.tableData.map(item => item.personId))
      
      this.UpdatePlayerInfo({
        personIdList,
        teamId:id
      });
    },
    UpdatePlayerInfo(data) {
      this.loading = true;
      this.loadingText = '更新中...';
      batchSumbit(data)
        .then(r => {
          this.loading = false;
          r = r.code;
          if (r == 0) {
            this.search();
            this.dialogTableVisible = false;
          }
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    onClose() {
      this.dialogInfoVisible = false;
    },
    onBack() {
      this.dialogTableVisible = false;
    },
    handleSelectionChange(val) {
      // let { id } = this.query;
      // if (val) {
      //   for (var i = 0; i < val.length; i++) {
      //     var item = val[i];
      //     item.ResourceId = RecordId;
      //   }
      // }
      this.multipleSelection = val;
      //console.log(this.multipleSelection);
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("确定要删除该行吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(()=>{
        row.ResourceId = null;
        this.loading = true;
        this.loadingText = '删除中...';
        remove({ idList: row.id })
          .then(r => {
            r = r.data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!"
              });
            }
            this.loading = false;
            this.search();
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      });
      
    },
  }
};
</script>